import { CloseOutlined, DeleteOutlined, PlusOutlined, SyncOutlined } from "@ant-design/icons"
import { Button, ColorPicker, Form, Input, Modal, Select } from "antd"
import { ChangeEvent, useEffect, useRef, useState } from "react"
import { useForm } from "antd/es/form/Form"
import { FormInstance, FormProps } from "antd/lib"
import { addListTarget } from "../../../../../api/target/targetApi"
import '../../styles.scss'
import useThrottle from "../../../../../hook/useThrottle"
import { editZnsProvider, IBrandConfigsZNS } from "../../../../../api/integrationProvider/integrationProvidersApi"

interface IBrandRow {
    id: string;
    brandName: string | undefined;
    carBrand: string | undefined;
    type: string | undefined;
}

let counter = 0;

const generateId = () => crypto.randomUUID();

interface ModalProps {
    isOpen: boolean
    infoProvider?: IBrandConfigsZNS
    onSubmitFormModal: (iSsuccess: boolean, errorMessage?: string) => void
    closeModal: (e: boolean) => void
}
const ModalUpdateCreateZNSProvider: React.FC<ModalProps> = ({
    isOpen, infoProvider,
    onSubmitFormModal, closeModal,
}) => {

    const [form] = useForm();

    const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {
        if (!infoProvider?.id) return
        const { zaloAppId, zaloAppSecret, zaloAppName, apiEndpoint } = values;

        const result = await editZnsProvider(
            infoProvider?.id, zaloAppId, zaloAppSecret, zaloAppName,
            apiEndpoint
        )
        if (result?.status) {
            onSubmitFormModal?.(true, result?.message)
        } else {
            onSubmitFormModal?.(false, result?.message)
        }
    }, 1000)

    useEffect(() => {
        if (isOpen) {
            if (infoProvider) {
                const { id, status,  } = infoProvider

                // form.setFieldsValue({
                //     zaloAppId,
                //     apiEndpoint,
                //     zaloAppName,
                //     zaloAppSecret
                // });
            }


        } else {
            form.resetFields()
        }
    }, [isOpen, infoProvider])
    return (

        <Form
            form={form}
            onFinish={onFinish}
            initialValues={{
                brandConfigs: [{}],
            }}
        >
            <Modal
                title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                    <span className="text-base text-344054 fw-500 font-medium">Cập nhật nhà cung cấp ZNS</span>
                    <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
                </div>}
                open={isOpen}
                onCancel={() => closeModal(false)}
                centered
                className="custom-modal-ant-history-child"
                closeIcon={false}
                footer={
                    <div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
                        <span className="text-sm text-98A2B3 cursor-pointer"
                            onClick={() => closeModal(false)}
                        >Huỷ</span>
                        <button
                            className="custom-page-css text-white text-sm bg-096DD9 border-none shadow-btn-save rounded h-8 px-15-px"
                            onClick={() => form.submit()}>
                            Lưu
                        </button>
                    </div>}
            >
                <div className="d-flex flex-column gap-18-px p-6">
                    <div className="d-flex flex-column gap-1">
                        <p className="text-sm  font-regular text-344054 ">
                            Zalo App ID:<span className="text-F5222D">*</span>
                        </p>
                        <Form.Item
                            name="zaloAppId"
                            rules={[{ required: true, message: 'Chọn tên nhà cung cấp!' }]}
                            className="m-none-form-item text-explan text-label"

                        >
                            <Input.Password
                                placeholder="Zalo App ID"
                                className="custom-input-css"
                            />
                        </Form.Item>
                    </div>
                    <div className="d-flex flex-column gap-1">
                        <p className="text-sm  font-regular text-344054 ">
                            Tên hiển thị Zalo App:<span className="text-F5222D">*</span>
                        </p>
                        <Form.Item
                            name="zaloAppName"
                            rules={[{ required: true, message: 'Nhập tên hiển thị Zalo App!' }]}
                            className="m-none-form-item text-explan text-label"

                        >
                            <Input
                                placeholder="Tên hiển thị Zalo App"
                                className="custom-input-css"
                            />
                        </Form.Item>
                    </div>
                    <div className="d-flex flex-column gap-1">
                        <p className="text-sm  font-regular text-344054 ">
                            Zalo App Secret:<span className="text-F5222D">*</span>
                        </p>
                        <Form.Item
                            name="zaloAppSecret"
                            rules={[{ required: true, message: 'Nhập Zalo App Secret!' }]}
                            className="m-none-form-item text-explan text-label"

                        >
                            <Input.Password
                                placeholder="Zalo App Secret"
                                className="custom-input-css"
                            />
                        </Form.Item>
                    </div>

                    <div className="d-flex flex-column gap-1">
                        <p className="text-sm  font-regular text-344054 ">
                            API Endpoint:<span className="text-F5222D">*</span>
                        </p>
                        <Form.Item
                            name="apiEndpoint"
                            rules={[{ required: true, message: 'Nhập API Endpoint!' }]}
                            className="m-none-form-item text-explan"
                        >
                            <Input
                                placeholder="API Endpoint"
                                className="custom-input-css"
                            />
                        </Form.Item>
                    </div>

                </div>
            </Modal>
        </Form>
    )
}
export default ModalUpdateCreateZNSProvider
